import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from "vue-property-decorator";
var ConfirmDialog = /*#__PURE__*/function (_Vue) {
  function ConfirmDialog() {
    var _this;
    _classCallCheck(this, ConfirmDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ConfirmDialog, [].concat(args));
    _defineProperty(_this, "visible", void 0);
    _defineProperty(_this, "title", void 0);
    _defineProperty(_this, "width", void 0);
    _defineProperty(_this, "closeOnOutsideClick", void 0);
    _defineProperty(_this, "showClose", void 0);
    _defineProperty(_this, "cancelBtnTitle", void 0);
    _defineProperty(_this, "confirmBtnTitle", void 0);
    _defineProperty(_this, "isDeleteAction", void 0);
    _defineProperty(_this, "isVisible", false);
    return _this;
  }
  _inherits(ConfirmDialog, _Vue);
  return _createClass(ConfirmDialog, [{
    key: "mounted",
    value: function mounted() {
      this.isVisible = this.visible;
    }
  }, {
    key: "onVisiblePropChanges",
    value: function onVisiblePropChanges() {
      this.isVisible = this.visible;
    }
  }, {
    key: "handleDialogClose",
    value: function handleDialogClose() {
      this.isVisible = false;
      return true;
    }
  }, {
    key: "handleConfirmAction",
    value: function handleConfirmAction() {
      this.isVisible = false;
      return true;
    }
  }]);
}(Vue);
export { ConfirmDialog as default };
__decorate([Prop({
  default: false
})], ConfirmDialog.prototype, "visible", void 0);
__decorate([Prop({
  default: ''
})], ConfirmDialog.prototype, "title", void 0);
__decorate([Prop({
  default: '560px'
})], ConfirmDialog.prototype, "width", void 0);
__decorate([Prop({
  default: true
})], ConfirmDialog.prototype, "closeOnOutsideClick", void 0);
__decorate([Prop({
  default: true
})], ConfirmDialog.prototype, "showClose", void 0);
__decorate([Prop({
  default: ''
})], ConfirmDialog.prototype, "cancelBtnTitle", void 0);
__decorate([Prop({
  default: ''
})], ConfirmDialog.prototype, "confirmBtnTitle", void 0);
__decorate([Prop({
  default: false
})], ConfirmDialog.prototype, "isDeleteAction", void 0);
__decorate([Watch('visible')], ConfirmDialog.prototype, "onVisiblePropChanges", null);
__decorate([Emit("dialog-close")], ConfirmDialog.prototype, "handleDialogClose", null);
__decorate([Emit("on-confirmed")], ConfirmDialog.prototype, "handleConfirmAction", null);